module.exports = __webpack_public_path__ + "static/media/Appreciation.f5118cbe.jpg";